import React, { useContext } from "react";
import { Form } from "antd";
import { Section, Visibility } from "../../../";
import { ActionButton } from "../../action-button";
import { PapersForm } from "../form";
import {
  EditProfileContext
} from "../../../../../contexts/shared/edit-profile";
import { formatValues } from "./format-values";

export function PapersEditSection({ editable = false }) {
  const {
    saveChanges,
    editing,
    setEditing,
    data
  } = useContext(EditProfileContext);

  const oldPapers = data?.user?.expertProfile?.professionalExperience?.papers || [];

  const onSave = () => {
    const { papers } = form.getFieldsValue();
    const data = formatValues(papers, oldPapers);

    saveChanges(data, "papers");
  };

  const [form] = Form.useForm();

  return (
    <Section
      spaced
      title="Investigaciones o publicaciones"
      bottom={
        <Visibility visible={editable}>
          <ActionButton
            editing={editing.papers && editable}
            setEditing={setEditing}
            formName="papers"
            visible
            onSave={onSave} />
        </Visibility>}>
      <PapersForm
        form={form}
        editable={editing.papers && editable} />
    </Section>
  );
}
